import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaFileInvoiceDollar } from "react-icons/fa";
import { List } from "../../shared/list/List";

export const ListaOrdemCompra = ({
  columns,
  data,
  page,
  setPage,
  limit,
  setLimit,
  total,
  loading,
  storageKey,
  setDataInicio,
  dataInicio,
  setDataFim,
  dataFim,
  handleFiltroData,
  handleFiltering,
  renderExpandedRow,
  getRowId,
  getRowStyle,
  legend,
}) => {
  const navigate = useNavigate();
  const [columnFilters, setColumnFilters] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const initialVisibleColumns = [
    "ordcom",
    "codope",
    "nomope",
    "valliq",
    "datped",
    "datenc",
    "datcan",
    "desfre",
    "qtdItens",
    "status",
  ];

  const handleVisualizarPropostas = (row) => {
    if (row?.ordcom) navigate(`/propostas/${row.ordcom}`);
  };

  const handleAplicarFiltroData = () => {
    handleFiltroData();
    setShowModal(false);
  };

  return (
    <List
      title="Ordens de Compra"
      text="Lista de Ordens de Compra"
      table={{ columns, data }}
      actions={[{
        icon: FaFileInvoiceDollar,
        onClick: handleVisualizarPropostas,
        title: "Visualizar Propostas"
      }]}
      page={page}
      setPage={setPage}
      limit={limit}
      setLimit={setLimit}
      total={total}
      onColumnFilterChange={handleFiltering}
      columnFilters={columnFilters}
      setColumnFilters={setColumnFilters}
      initialVisibleColumns={initialVisibleColumns}
      setDataInicio={setDataInicio}
      dataInicio={dataInicio}
      setDataFim={setDataFim}
      dataFim={dataFim}
      handleFilterData={handleAplicarFiltroData}
      showModal={showModal}
      setShowModal={setShowModal}
      storageKey={storageKey}
      loading={loading}
      renderExpandedRow={renderExpandedRow}
      getRowId={getRowId}
      getRowStyle={getRowStyle}
      legend={legend}
      enableRowSelection={false}
      expandWithIndicatorOnly
    />
  );
};
